import Image from "next/image";
import Link from "next/link";

import type { SiteLocale } from "@/lib/graphql";

import { type FragmentOf, readFragment } from "~/lib/graphql";

import * as fragment from "./graphql";

interface ImageBlock {
  id: string;
  title?: string | null;
  text?: string | null;
  image?: {
    id: string;
    url: string;
    alt?: string | null;
    focalPoint?: {
      x: number;
      y: number;
    } | null;
    height: number | null;
    width: number | null;
    title?: string | null;
    copyright?: string | null;
    author?: string | null;
    thumbhash: string | null;
    blurUpThumb?: string | null;
  } | null;
}

export function GalleryGrid(props: {
  record: FragmentOf<typeof fragment.galleryGridFragment>;
  locale: SiteLocale;
}) {
  const record = readFragment(fragment.galleryGridFragment, props.record);

  const BlockText = ({ block }: { block: ImageBlock }) => (
    <>
      {/* {(block?.title || block?.text) && (
        <div className="bg-valencia absolute left-0 top-0 flex h-full w-full flex-col items-start justify-center overflow-hidden p-5 text-white opacity-0 group-hover:opacity-100">
          {block.title && (
            <h3 className="mb-2 max-w-[420px] text-xl font-semibold">{block.title}</h3>
          )}
          {block.text && (
            <p className="max-w-[420px] text-base leading-[120%]">{block.text}</p>
          )}
        </div>
      )} */}
    </>
  );

  const SvgIcon = () => (
    <div className="bg-valencia absolute top-0 left-0 z-20 flex h-full w-full overflow-hidden p-5 text-white transition-all group-hover:opacity-100 md:mt-10 md:ml-10">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="187"
        height="187"
        fill="none"
        viewBox="0 0 187 187"
      >
        <circle cx="93.5" cy="93.5" r="93.5" fill="#DF1B12"></circle>
        <g clipPath="url(#clip0_6715_1082)">
          <circle
            cx="93"
            cy="149"
            r="19.375"
            stroke="#fff"
            strokeWidth="1.25"
            className="transition-all group-hover:fill-white"
          ></circle>
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M92.16 139h1.472l-.024 12.178 3.88-3.881 1.034 1.034-5.133 5.134a.71.71 0 0 1-.517.22.71.71 0 0 1-.517-.22l-5.134-5.134 1.034-1.034 3.905 3.868zM83 157.54h19.793V159H83z"
            clipRule="evenodd"
            className="group-hover:fill-eurac-red transition-all"
          ></path>
        </g>
        {/* <text
          xmlSpace="preserve"
          fill="#fff"
          fontFamily="Milo Pro"
          fontSize="28"
          letterSpacing="0em"
          style={{ whiteSpace: "pre" }}
        >
          <tspan x="29.83" y="81.212">
            Download
          </tspan>
          <tspan x="17.758" y="109.212">
            Kurzversion
          </tspan>
        </text> */}
        <defs>
          <clipPath id="clip0_6715_1082">
            <path fill="#fff" d="M73 129h40v40H73z"></path>
          </clipPath>
        </defs>
      </svg>
      {props.locale === "de" ? (
        <span className="font-milo absolute top-0 left-0 z-40 mt-5 ml-5 flex h-[187px] w-[187px] items-center justify-center pb-3 text-center text-[28px] leading-none font-black">
          Download <br />
          Kurzversion
        </span>
      ) : (
        <span className="font-milo absolute top-0 left-0 z-40 mt-5 ml-5 flex h-[187px] w-[187px] items-center justify-center pb-6 text-center text-[24px] leading-none font-black">
          scarica la
          <br /> versione <br /> breve
        </span>
      )}
    </div>
  );

  const hasLink = record?.imageblock[0]?.title;

  const renderContent = () => (
    <>
      {record.grid === "half" ? (
        <div className="grid columns-1 gap-[16px] md:columns-2 md:grid-cols-2">
          {record.imageblock &&
            record.imageblock.map((block) => (
              <div key={block.id} className="group relative">
                {block.image && (
                  <Image
                    key={block.image.id}
                    src={`${block.image.url}?w=682&h=441&fit=crop&crop=focalpoint&fp-x=${block.image?.focalPoint?.x}&fp-y=${block.image?.focalPoint?.y}&auto=[format,compress]&cs=origin&dpr=1`}
                    alt={block.image?.alt || ""}
                    width={682}
                    height={441}
                    unoptimized
                    className="h-auto w-full max-w-full"
                    placeholder="blur"
                    blurDataURL={
                      block?.image?.blurUpThumb ||
                      "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs="
                    }
                  />
                )}

                {block && <BlockText block={block} />}
              </div>
            ))}
        </div>
      ) : record.grid === "2thirds1third" ? (
        <div className="relative grid gap-[16px] md:grid-cols-3">
          {hasLink && <SvgIcon />}
          {record.imageblock.map((block, index) => {
            return (
              <div
                key={block.id}
                className={`group relative ${index === 0 ? "md:col-span-2 md:row-span-2" : ""}`}
              >
                {block.image && index === 0 ? (
                  <div key={block.image.id} className="">
                    <Image
                      key={block.image.id}
                      src={`${block.image.url}?w=888&h=592&fit=crop&crop=focalpoint&fp-x=${block.image?.focalPoint?.x}&fp-y=${block.image?.focalPoint?.y}&auto=[format,compress]&cs=origin&dpr=2`}
                      alt={block.image?.alt || ""}
                      width={888}
                      height={592}
                      unoptimized
                      className="w-full max-w-full"
                      placeholder="blur"
                      blurDataURL={
                        block?.image?.blurUpThumb ||
                        "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs="
                      }
                    />

                    <BlockText block={block} />
                  </div>
                ) : block.image && index === 1 ? (
                  <div key={block.image.id} className="">
                    <Image
                      key={block.image.id}
                      src={`${block.image.url}?w=436&h=288&fit=crop&crop=focalpoint&fp-x=${block.image?.focalPoint?.x}&fp-y=${block.image?.focalPoint?.y}&auto=[format,compress]&cs=origin&dpr=2`}
                      alt={block.image?.alt || ""}
                      width={436}
                      height={288}
                      unoptimized
                      className="w-full max-w-full"
                      placeholder="blur"
                      blurDataURL={
                        block?.image?.blurUpThumb ||
                        "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs="
                      }
                    />
                    <BlockText block={block} />
                  </div>
                ) : block.image && index === 2 ? (
                  <div key={block.image.id} className="">
                    <Image
                      key={block.image.id}
                      src={`${block.image.url}?w=436&h=288&fit=crop&crop=focalpoint&fp-x=${block.image?.focalPoint?.x}&fp-y=${block.image?.focalPoint?.y}&auto=[format,compress]&cs=origin&dpr=2`}
                      alt={block.image?.alt || ""}
                      width={436}
                      height={288}
                      unoptimized
                      className="w-full max-w-full"
                      placeholder="blur"
                      blurDataURL={
                        block?.image?.blurUpThumb ||
                        "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs="
                      }
                    />
                    <BlockText block={block} />
                  </div>
                ) : (
                  <></>
                )}
              </div>
            );
          })}
        </div>
      ) : record.grid === "1third2thirds" ? (
        <div className="grid gap-[16px] md:grid-cols-3">
          {record.imageblock.map((block, index) => {
            return (
              <div
                key={block.id}
                className={`group relative ${index === 1 ? "md:col-span-2" : ""}`}
              >
                {block.image && index === 0 ? (
                  <div key={block.image.id} className="group">
                    <Image
                      key={block.image.id}
                      src={`${block.image.url}?w=436&h=290&fit=crop&crop=focalpoint&fp-x=${block.image?.focalPoint?.x}&fp-y=${block.image?.focalPoint?.y}&auto=[format,compress]&cs=origin&dpr=1`}
                      alt={block.image?.alt || ""}
                      width={436}
                      height={290}
                      unoptimized
                      className="w-full max-w-full"
                      placeholder="blur"
                      blurDataURL={
                        block?.image?.blurUpThumb ||
                        "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs="
                      }
                    />
                    <BlockText block={block} />
                  </div>
                ) : block.image && index === 1 ? (
                  <div key={block.image.id} className="group">
                    <Image
                      key={block.image.id}
                      src={`${block.image.url}?w=888&h=592&fit=crop&crop=focalpoint&fp-x=${block.image?.focalPoint?.x}&fp-y=${block.image?.focalPoint?.y}&auto=[format,compress]&cs=origin&dpr=1`}
                      alt={block.image?.alt || ""}
                      width={888}
                      height={592}
                      unoptimized
                      className="w-full max-w-full"
                      placeholder="blur"
                      blurDataURL={
                        block?.image?.blurUpThumb ||
                        "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs="
                      }
                    />
                    <BlockText block={block} />
                  </div>
                ) : (
                  <></>
                )}
              </div>
            );
          })}
        </div>
      ) : record.grid === "third" ? (
        <div className="grid columns-1 gap-[16px] md:columns-3 md:grid-cols-3">
          {record.imageblock.map((block) => (
            <div key={block.id} className="group relative">
              {block.image && (
                <Image
                  key={block.image.id}
                  src={`${block.image.url}?w=436&h=290&fit=crop&crop=focalpoint&fp-x=${block.image?.focalPoint?.x}&fp-y=${block.image?.focalPoint?.y}&auto=[format,compress]&cs=origin&dpr=1`}
                  alt={block.image?.alt || ""}
                  width={436}
                  height={290}
                  unoptimized
                  className="h-auto w-full max-w-full"
                  placeholder="blur"
                  blurDataURL={
                    block?.image?.blurUpThumb ||
                    "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs="
                  }
                />
              )}
              <BlockText block={block} />
            </div>
          ))}
        </div>
      ) : (
        <></>
      )}
    </>
  );

  return hasLink ? (
    <>
      {record?.imageblock[0]?.title && (
        <Link
          className={`group container mx-auto mb-10 block cursor-pointer`}
          href={record.imageblock[0].title || "#"}
        >
          {renderContent()}
        </Link>
      )}
    </>
  ) : (
    <div className={`container mx-auto mb-10`}>{renderContent()}</div>
  );
}
